/** @import { Signal } from "@preact/signals-core" */
import { batch, signal } from "@preact/signals-core";
import { moduleName, sceneFlags } from "../consts.mjs";

export const canvasReady$ = signal(false);

/** Position of the cursor in world coordinate space. */
export const cursorWorldPosition$ = signal({ x: 0, y: 0 });

/** @type {Signal<Set<string>>} */
export const invisibleTerrainTypes$ = signal(new Set());

/** @type {Signal<boolean | null>} */
export const sceneRenderAboveTilesChoice$ = signal(null);

export function onUpdateScene(scene) {
	// A scene other than the one the current user is on was updated
	if (scene.id !== canvas.scene.id) return;
	onCanvasReady({ scene });
}

export function onCanvasReady({ scene }) {
	batch(() => {
		invisibleTerrainTypes$.value = new Set(scene.getFlag(moduleName, sceneFlags.invisibleTerrainTypes) ?? []);
		sceneRenderAboveTilesChoice$.value = scene.getFlag(moduleName, sceneFlags.terrainLayerAboveTiles) ?? null;
		canvasReady$.value = true;
	});
}

export function onCanvasTearDown() {
	batch(() => {
		canvasReady$.value = false;
		invisibleTerrainTypes$.value = new Set();
		sceneRenderAboveTilesChoice$.value = null;
	});
}
